import { Controller } from "@hotwired/stimulus";
import moment from "moment";
import * as echarts from "echarts";

export default class extends Controller {
  static targets = ["chartBody"];

  connect() {
    this.chart = null;
    this.initializeChart();
  }

  initializeChart() {
    if (!this.hasChartBodyTarget) {
      return;
    }

    this.chart = echarts.init(this.chartBodyTarget);
    this.chart.setOption({
      tooltip: {
        trigger: "axis",
        axisPointer: {
          label: {
            formatter: function (params) {
              return moment(params.value).format("dddd, MMM D, h:mm a");
            },
          },
        },
      },
      xAxis: {
        type: "time",
      },
      yAxis: {
        type: "value",
      },
      dataZoom: [
        {
          start: 0,
          end: 100,
        },
      ],
      series: [
        {
          name: "Notices",
          type: "line",
          color: ["#DB6243"],
        },
      ],
      grid: {
        containLabel: true,
        left: "0",
        right: "15",
        top: "20",
        bottom: "40",
      },
    });
  }

  updateData(e) {
    this.noticeVolumeData = e.detail.data;
    this.redrawChart();
    this.resizeChart();
  }

  redrawChart() {
    if (!this.chart) {
      return;
    }

    this.chart.setOption({
      series: this.noticeVolumeData,
    });
  }

  resizeChart() {
    if (!this.chart) {
      return;
    }

    this.chart.resize();
  }
}
